import { getMethod } from '../../http-server';

export const getListClientReport = async (params: any) => {
  try {
    const response = await getMethod(`client/report/list`, params);
    return response.data;
  } catch (error) {
    console.error('Error featching data: ', error);
  }
};
